clearMenu = function(){
	$('#niozHeader .menu-small').removeClass('menu-small');
	$('#niozHeader .open-child').removeClass('open-child');
	$('#niozHeader .overlay').hide();
	$('#niozHeader .menu-small-button').removeClass('active');
}
openMenu = function(){
	$('#niozHeader .overlay').show();
	$('#niozHeader .menu-small-button').addClass('active');
}

$.getJSON('https://dataportal.nioz.nl/apps/api/menubar', function(menu){
	$.each(menu, function(_i, main){
		if(main.applications.length){
			$('#niozHeader #mainmenu > ul').append('<li id="menu_'+main.id+'"><span>'+main.name+'</span><ul></ul></li>');
			$.each(main.applications, function(_i, app){
				$('#niozHeader #menu_'+main.id+' ul').append('<li><a href="'+app.url+'">'+app.name+'</a></li>');
			});
		} else {
			$('#niozHeader #mainmenu > ul').append('<li><a href="'+main.url+'">'+main.name+'</a></li>');
		}
	});
	$('#niozHeader li').each(function(){
		if($(this).children('ul').length > 0){
			$(this).on('click', function(e){
				if($(this).hasClass('open-child') && !$('#mainmenu').hasClass('menu-small')){
					clearMenu();
				} else {
					openMenu();
					$('#niozHeader .open-child').removeClass('open-child');
					$(this).addClass('open-child');
				}
				e.stopPropagation();
			});
		}
	});
});

$().ready(function(){
	$('#niozHeader .menu-small-button').on('click', function(e){
		if($('#niozHeader #mainmenu').hasClass('menu-small')){
			clearMenu();
		} else {
			openMenu();
			$('#niozHeader #mainmenu').addClass('menu-small');
		}
		e.stopPropagation();
	});
	$('body').on('click', clearMenu);
	$(window).on('resize', clearMenu);
});